import { ProductoTiendaDsKey } from "../../business/entities/ProductoTiendaDsKey";


export class ProductoTiendaDsKeyModel implements ProductoTiendaDsKey {

    constructor(
        public shopCodProd: string,
        public idProdVerPres: string
    ) { }

    serialize(): ProductoTiendaDsKey {
        return {
            shopCodProd: this.shopCodProd,
            idProdVerPres: this.idProdVerPres
        };
    }
    
    static deserialize(formatoBase: ProductoTiendaDsKey): ProductoTiendaDsKeyModel {
        return new ProductoTiendaDsKeyModel(
            formatoBase.shopCodProd,
            formatoBase.idProdVerPres,
        );
    }
}
